// Utils Exclusive for Entities
export const admitedEntities = {
	"clients": {
		single: "Cliente",
		plural: "Clientes"
	},
	"suppliers": {
		single: "Proveedor",
		plural: "Proveedores"
	},
};